import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';
import { categories, articles } from '@/mocks/data';

const categoryMeta: Record<string, { title: string; description: string; keywords: string }> = {
  jiqiao: {
    title: '口交技巧 | 从入门到进阶的完全指南 - 亲密指南',
    description: '从基础到进阶的口交技巧完全指南，涵盖体位选择、节奏控制、进阶方法和常见误区纠正，帮助伴侣探索更多愉悦体验，提升亲密关系质量。',
    keywords: '口交技巧,口交基础入门,口交进阶方法,口交体位,口交节奏控制,性愉悦提升',
  },
  anquan: {
    title: '口交安全防护 | 性传播疾病防护全攻略 - 亲密指南',
    description: '口交同样存在性传播感染风险。本文详细介绍口交相关的STI风险、安全套和口腔保护膜的规范使用、疫苗接种建议以及定期检测的重要性。',
    keywords: '口交安全,性传播疾病防护,口交STI风险,安全套使用,口腔保护膜,HPV疫苗',
  },
  weisheng: {
    title: '口交卫生与健康 | 清洁护理与注意事项 - 亲密指南',
    description: '口交前后的卫生习惯对双方健康至关重要。提供详细清洁步骤、应避免的行为以及日常生殖健康护理建议，确保安全健康的亲密体验。',
    keywords: '口交卫生,口交清洁护理,生殖器卫生,口交健康注意事项,性行为卫生',
  },
  goutong: {
    title: '口交沟通与心理 | 建立信任与舒适感 - 亲密指南',
    description: '如何与伴侣坦诚沟通口交偏好，克服焦虑与羞耻感，建立信任与舒适感。从心理学角度提供实用的沟通策略和心理调适方法。',
    keywords: '口交沟通,伴侣沟通技巧,性心理障碍克服,口交焦虑,性羞耻感,亲密关系沟通',
  },
  xingjiankang: {
    title: '口交与性健康 | 科学认识与健康知识 - 亲密指南',
    description: '从科学角度了解口交与整体性健康的关系，包括生理影响、荷尔蒙变化、对亲密关系的积极效应以及常见健康问题的预防方法。',
    keywords: '口交性健康,性生理知识,性健康科学,口交健康益处,性教育知识',
  },
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || 'jiqiao');

  useEffect(() => {
    if (slug) setActiveCategory(slug);
  }, [slug]);

  const currentCat = categories.find((c) => c.slug === activeCategory) || categories[0];
  const catArticles = articles.filter((a) => a.category === activeCategory);
  const meta = categoryMeta[activeCategory] || categoryMeta.jiqiao;

  const catSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${currentCat.name} - 亲密指南`,
    description: currentCat.description,
    url: `https://climaxpro.github.io/category/${activeCategory}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '亲密指南',
      url: 'https://climaxpro.github.io',
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://climaxpro.github.io/' },
      { '@type': 'ListItem', position: 2, name: currentCat.name, item: `https://climaxpro.github.io/category/${activeCategory}` },
    ],
  };

  return (
    <Layout>
      <SEOHead
        title={meta.title}
        description={meta.description}
        keywords={meta.keywords}
        canonicalUrl={`/category/${activeCategory}`}
        ogType="website"
        schema={{ ...catSchema, ...breadcrumbSchema }}
      />

      <div className="pt-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb items={[{ label: '首页', to: '/' }, { label: currentCat.name }]} />

          <div className="mb-10">
            <h1 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-950 mb-3">
              {currentCat.name}
            </h1>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl">
              {currentCat.description}
            </p>
          </div>

          <div className="flex items-center gap-2 overflow-x-auto pb-3 mb-10 scrollbar-hide">
            <div className="flex bg-background-100 rounded-full px-1 py-1 gap-1">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    activeCategory === cat.slug
                      ? 'bg-primary-500 text-white'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pb-20">
            {catArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={getArticleImage(article.slug)}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs text-foreground-500">{article.readTime}</span>
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {article.summary}
                  </p>
                </div>
              </Link>
            ))}
          </div>

          {catArticles.length === 0 && (
            <div className="text-center py-20">
              <p className="text-foreground-500">该分类下暂无文章</p>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}

function getArticleImage(slug: string): string {
  const images: Record<string, string> = {
    'koujiao-jichu-ru-men-zhi-nan': 'https://readdy.ai/api/search-image?query=Warm%20soft%20minimalist%20abstract%20background%20with%20gentle%20rose%20and%20cream%20tones%2C%20flowing%20organic%20shapes%2C%20elegant%20texture%2C%20mood%20of%20intimacy%20and%20trust%2C%20editorial%20quality%20with%20subtle%20gradients%2C%20calm%20serene%20atmosphere%2C%20no%20human%20figures%2C%20artistic%20abstract%20composition&width=600&height=300&seq=article-basic-guide&orientation=landscape',
    'koujiao-jiqiao-gaoji-zhi-yin': 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20composition%20with%20warm%20terracotta%20and%20cream%20gradients%2C%20flowing%20curves%20suggesting%20rhythm%20and%20harmony%2C%20soft%20lighting%20textures%2C%20artistic%20minimalist%20design%2C%20sophisticated%20editorial%20background%2C%20no%20figures%2C%20serene%20and%20intimate%20mood&width=600&height=300&seq=article-advanced-skills&orientation=landscape',
    'koujiao-yu-annquan-xing-chuan-bo-ji-bing-fang-hu': 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20abstract%20background%20with%20soft%20cream%20and%20warm%20neutral%20tones%2C%20geometric%20shield-like%20shapes%20subtly%20integrated%2C%20professional%20medical-educational%20aesthetic%2C%20calm%20trustworthy%20atmosphere%2C%20no%20human%20figures%2C%20editorial%20quality%20with%20soft%20lighting&width=600&height=300&seq=article-safety-protection&orientation=landscape',
    'koujiao-ganran-zheng-zhuang-zao-qi-shi-bie': 'https://readdy.ai/api/search-image?query=Soft%20abstract%20medical-educational%20background%20with%20warm%20beige%20and%20cream%20tones%2C%20subtle%20geometric%20patterns%2C%20professional%20clinical%20aesthetic%20with%20human%20touch%2C%20calming%20trustworthy%20atmosphere%2C%20editorial%20quality%2C%20no%20human%20figures&width=600&height=300&seq=article-symptoms&orientation=landscape',
    'koujiao-qian-hou-wei-sheng-zhi-nan': 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20spa-like%20abstract%20background%20with%20soft%20cream%20and%20pale%20rose%20tones%2C%20water-like%20flowing%20textures%2C%20fresh%20pure%20atmosphere%2C%20editorial%20quality%2C%20calm%20and%20serene%20mood%2C%20no%20human%20figures%2C%20elegant%20composition&width=600&height=300&seq=article-hygiene&orientation=landscape',
    'nan-xing-sheng-zhi-qi-wei-sheng-hu-li': 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20background%20with%20warm%20neutral%20beige%20and%20cream%20gradients%2C%20clean%20modern%20aesthetic%2C%20bathroom-spa%20inspired%20soft%20textures%2C%20editorial%20quality%2C%20professional%20yet%20warm%20atmosphere%2C%20no%20human%20figures&width=600&height=300&seq=article-male-hygiene&orientation=landscape',
    'yu-ban-lv-gou-tong-kou-jiao-xi-hao': 'https://readdy.ai/api/search-image?query=Warm%20intimate%20abstract%20background%20with%20soft%20rose%20and%20cream%20gradients%2C%20two%20flowing%20organic%20shapes%20intertwining%20harmoniously%2C%20gentle%20editorial%20aesthetic%2C%20mood%20of%20trust%20and%20closeness%2C%20no%20human%20figures%2C%20calm%20serene%20atmosphere&width=600&height=300&seq=article-communication&orientation=landscape',
    'koujiao-zhong-xin-li-zhang-ai-ke-fu': 'https://readdy.ai/api/search-image?query=Soft%20abstract%20background%20with%20gentle%20warm%20beige%20and%20cream%20gradients%2C%20calming%20atmospheric%20shapes%2C%20mindfulness-inspired%20composition%2C%20peaceful%20meditative%20aesthetic%2C%20editorial%20quality%2C%20no%20human%20figures%2C%20serene%20tranquil%20mood&width=600&height=300&seq=article-psychology&orientation=landscape',
    'koujiao-yu-zheng-ti-xing-jian-kang': 'https://readdy.ai/api/search-image?query=Scientific%20educational%20abstract%20background%20with%20warm%20cream%20and%20soft%20earth%20tones%2C%20subtle%20molecular-wave%20patterns%2C%20professional%20medical%20aesthetic%20with%20human%20warmth%2C%20editorial%20quality%2C%20no%20human%20figures%2C%20calm%20trustworthy%20atmosphere&width=600&height=300&seq=article-health-science&orientation=landscape',
  };
  return images[slug] || '';
}